import { render, staticRenderFns } from "./AccountBackofficeAdd.vue?vue&type=template&id=08dc46c9&"
import script from "./AccountBackofficeAdd.vue?vue&type=script&lang=js&"
export * from "./AccountBackofficeAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountBackofficeAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports